import React from 'react';
import { FormattedMessage } from 'react-intl';

import Sidebar from 'carbon-react/lib/components/sidebar';
import Typography from 'carbon-react/lib/components/typography';

import { DriverGroupWizardContainer } from './driver-group-wizard-container';

interface CreateDriverGroupSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateDriverGroupSidebar = ({ isOpen, onClose }: CreateDriverGroupSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="common.create_group" defaultMessage="Create group" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <DriverGroupWizardContainer onClose={onClose} />
  </Sidebar>
);
